import React, { useState } from "react";
import Loading from "./Loading";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";

const AddRecipeForm = () => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [user, setUser] = useState("");
  const [ingredients, setIngredients] = useState([]);
  const [singleIngredient, setSingleIngredient] = useState("");
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const navigate = useNavigate();
  const [header, setHeader] = useState("Add New Recipe");

  //post request
  const postRecipe = () => {
    setIsLoading(true);
    axios
      .post("https://the-menu-server-a0c079ab1940.herokuapp.com/api/recipes", {
        title,
        user,
        image,
        ingredients,
        description,
        note,
      })
      .then((response) => {
        if (response.status === 200) {
          setTitle("");
          setSingleIngredient("");
          setImage("");
          setNote("");
          setDescription("");
          setUser("");
          setHeader(response.data.message); // Retrieve the message from the response data
          window.scrollTo({ top: 0 });
          setTimeout(() => {
            navigate("/");
          }, 2000);
        } else {
          throw new Error("Something went wrong");
        }
      })

      .catch((error) => {
        console.error("Error adding recipe:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //add single ingredient function
  const addIngredient = (ingredient) => {
    if (singleIngredient.length === 0) {
      return;
    }
    setIngredients((current) => [...current, ingredient]);
    setSingleIngredient("");
  };
  //remove ingredient
  const removeItem = (indexToRemove) => {
    setIngredients((prev) => {
      const newArray = [...prev];
      newArray.splice(indexToRemove, 1);
      return newArray;
    });
  };
  //submit form logic
  const handleSubmit = (e) => {
    e.preventDefault();
    postRecipe();
  };

  //handle image upload
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
  };

  //convert image to string
  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  return (
    <div className="home-cnt add">
      <Form
        onSubmit={handleSubmit}
        className="addItems container justify-content-center align-items-center my-4 mx-auto max-width-800"
      >
        <Form.Group controlId="title">
          <h1 style={{ fontFamily: "monospace", backgroundColor: "#fff" }}>
            {" "}
            <span style={{ color: "grey" }}>|</span> {header}
          </h1>
          <Form.Label>Recipe's name:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter recipe's name"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required={true}
          />
        </Form.Group>
        <Form.Group controlId="user">
          <Form.Label>Your name:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your name :)"
            value={user}
            onChange={(e) => setUser(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="note">
          <Form.Label>Notes:</Form.Label>
          <Form.Control
            as="textarea"
            placeholder="Enter a note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Form.Group>
        {isLoading && <Loading />}
        <Form.Group controlId="ingredients">
          <Form.Label>Ingredients:</Form.Label>
          <div style={{ display: "flex" }} className="ingredients-cnt">
            <Form.Control
              type="text"
              placeholder="Enter ingredient and then add"
              value={singleIngredient}
              onChange={(e) => setSingleIngredient(e.target.value)}
            />
            <Button
              onClick={() => addIngredient(singleIngredient)}
              variant="primary"
            >
              ADD
            </Button>
          </div>
          <div className="show-ingredients">
            {ingredients &&
              ingredients.map((item, index) => (
                <p
                  onClick={() => removeItem(index)}
                  className="ingredient"
                  key={index}
                >
                  {item} <RxCrossCircled />
                </p>
              ))}
          </div>
        </Form.Group>
        <Form.Group controlId="description">
          <Form.Label>Cooking instructions:</Form.Label>
          <Form.Control
            as="textarea"
            placeholder="Enter instructions"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required={true}
          />
        </Form.Group>
        {/* image upload logic here */}
        <label htmlFor="image">Add image:</label>
        <br />
        <input
          style={{ marginTop: "10px" }}
          type="file"
          accept=".jpeg, .png , .jpg"
          onChange={(e) => handleFileUpload(e)}
          id="image"
          required={false}
        />
        <br />
        {image == "" || image == null ? (
          ""
        ) : (
          <img style={{ width: "200px", height: "100px" }} src={image} alt="" />
        )}{" "}
        <Button
          className="d-flex align-items-center my-4 justify-content-center"
          variant="primary"
          type="submit"
        >
          Add Recipe
        </Button>
      </Form>
    </div>
  );
};

export default AddRecipeForm;
